import React, { useContext, useState } from 'react';
import { social_gmail, social_github, social_linkedin } from '../assets/index.js';
import { motion } from 'framer-motion';
import { themeContext } from '../context/Theme'
import { useTranslation } from 'react-i18next';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import withScrollReveal from '../animattion/withScrollReveal.jsx';


const Contact = () => {

  const [val, setVal] = useState({
    name: '',
    email: '',
    mobile: '',
    message: ''
  });
  const { dark } = useContext(themeContext);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);



  const notify = (type) => {
    switch (type) {
      case 'SUCCESS':
        toast.success("Details submitted successfully",
          { position: toast.POSITION.TOP_CENTER }
        );
        break;

      case 'ERROR':
        toast.error("something worng!!",
          { position: toast.POSITION.TOP_CENTER }
        );
        break;
      default: toast("error")
        break;
    }
  };

  //start
  const [errors, setErrors] = useState({
    email: '',
    mobile: ''
  });
  //end

  const handleChange = (e) => {
    const { name, value } = e.target;
    setVal({
      ...val,
      [name]: value
    });
    validateField(name, value, val);
  };

  const validateField = (fieldName, value, formData) => {
    let fieldError = '';
  
    switch (fieldName) {
      case 'email':
        fieldError = value ? !validateEmail(value) && 'Invalid email' : 'Email is required';
        break;
      case 'mobile':
        fieldError = value !== '' && !validateMobile(value) && 'Invalid mobile number';
        break;
      default:
        break;
    }
  
    setErrors({
      ...errors,
      [fieldName]: fieldError
    });
  };
  

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validateMobile = (mobile) => {
    const mobileRegex = /^\d{10}$/;
    return mobileRegex.test(mobile);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const response = await fetch('https://formspree.io/f/xaygwrbp', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(val)
    });

    if (response.ok) {
      // Reset form fields
      setVal({
        name: '',
        email: '',
        mobile: '',
        message: ''
      });

      // Clear errors
      setErrors({
        email: '',
        mobile: ''
      });

      // Show success message
      notify('SUCCESS');
      setLoading(false);
    } else {
      // Show error message
      notify('ERROR');
      setLoading(false);
    }

  };
  


  return (
    <div id='Contact' className="h-auto w-auto">
      <p className='text-center text-[2rem] font-bold'> {t('Contact')} </p>

      <div className='w-[100%] py-6 flex flex-col flex-wrap gap-4 md:gap-0 md:flex-row md:justify-center '>

        <div className="h-[50%] w-full md:h-full md:w-[50%] md:pr-4 ">
          <p className='text-justify'> {t('Contact_txt')}
          </p>
          <div className=" flex flex-wrap gap-2 mt-4 justify-center md:justify-start" >

            <a href="mailto:shubhamvaishnav.dev@gmail.com" >
              <motion.img src={social_gmail} alt="gmail" whileHover={{ scale: 1.2 }} title='gmail' loading='lazy' className='h-8 md:h-10' />
            </a>
            <a href="https://github.com/shubhamvaishnavdev">
              <motion.img src={social_github} alt="github" whileHover={{ scale: 1.2 }} title='github' loading='lazy' className='h-8 md:h-10' />
            </a>
            <a href="https://www.linkedin.com/in/shubham-vaishnav-dev/">
              <motion.img src={social_linkedin} alt="linkedin" whileHover={{ scale: 1.2 }} title='linkedin' loading='lazy' className='h-8 md:h-10 ' />
            </a>
          </div>
        </div>

        <div className="h-[50%] w-full md:h-full md:w-[50%] md:pl-4">

          <form
            name="contact"
            action='https://formspree.io/f/xaygwrbp'
            method="POST"
            onSubmit={handleSubmit}

            className={` w-full p-8 rounded-xl  ${dark ? 'bg-dark_gray text-white' : 'bg-slate-800 text-white'}`}>

            <label htmlFor="NAME" className='block'>Name</label>
            <input type="text"
              name="name"
              id='NAME'
              value={val.name}
              onChange={handleChange}
              placeholder='john doe'
              required
              className='w-full h-[1.8rem] pl-2 placeholder-gray-300 focus:outline-none bg-light_gray' />


            <label htmlFor="EMAIL" className='block pt-2'>Email</label>
            <input type="email"
              name="email"
              id='EMAIL'
              value={val.email}
              onChange={handleChange}
              placeholder='john@gmail.com'
              required
              className='w-full h-[1.8rem] pl-2 placeholder-gray-300 focus:outline-none bg-light_gray' />
            {errors.email && <span className="error">{errors.email}</span>}


            <label htmlFor="MOBILE" className='block pt-2'>Mobile</label>
            <input type="text"
              name="mobile"
              id='MOBILE'
              value={val.mobile}
              onChange={handleChange}
              placeholder='XXXXXXXXXX (optional)'
              className='w-full h-[1.8rem] pl-2 placeholder-gray-300 focus:outline-none bg-light_gray' />
            {errors.mobile && <span className="error">{errors.mobile}</span>}


            <label htmlFor="MESSAGES" className='block pt-2'>Message</label>
            <textarea
              name="message"
              id="MESSAGES"
              value={val.message}
              onChange={handleChange}
              placeholder='Write your message here...'
              required
              className='block h-[14rem] w-full pl-2 placeholder-gray-300 place-items-center focus:outline-none bg-light_gray'></textarea>


            <motion.button type='submit'
              whileHover={{ scale: 1.1 }}
              disabled={loading}
              className='bg-blue px-4 py-1 mt-2'>
                {
                 loading ? (
                  <div className="flex items-center justify-center">
                    <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-white"></div>
                  </div>
                ) : (
                  'send'
                )
                }
              </motion.button>
            <ToastContainer autoClose={2000} />
          </form>
        </div>
      </div>
    </div>
  )
}

export default withScrollReveal(Contact);